import { Button, Grid, TextField, Typography, Container, Box, Alert, InputAdornment, IconButton } from "@mui/material";
import { Link as MuiLink } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useContext, useState } from "react";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import { AuthContest } from "../utils/AuthContext";
import axios from "axios";
import Header from "../../components/Header";
import { Helmet } from "react-helmet";

import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

export default function LoginBus() {
  const [validated, setValidated] = useState(false);
  const navigate = useNavigate();
  const [credidentials, setCredidentials] = useState({
    email: "",
    password: "",
  });
  const { loading, error, dispatch } = useContext(AuthContest);

  // État pour afficher/masquer le mot de passe
  const [showPassword, setShowPassword] = useState(false);

  const handleChange = (e) => {
    setCredidentials((prev) => ({ ...prev, [e.target.id]: e.target.value }));
  };

  const handleClickShowPassword = () => {
    setShowPassword((show) => !show);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    dispatch({ type: "LOGIN_START" });
    try {
      const res = await axios({
        method: "post",
        url: "https://api.komorotel.com/api/business/login",
        headers: { "Content-Type": "application/json" },
        data: {
          email: credidentials.email,
          password: credidentials.password,
        },
      });

      Cookies.set("access_token", res.data.access_token, {
        path: "/",
      });

      dispatch({ type: "LOGIN_SUCCESS", payload: res.data });
      navigate("/");
    } catch (err) {
      dispatch({ type: "LOGIN_ERROR", payload: err.response.data });
      console.log(err);
    }
  };

  return (
    <>
      <Helmet>
        <title>Connexion - Komorotel</title>
        <meta name="description" content="Connectez-vous à votre compte Komorotel pour gérer vos réservations d’hôtels aux Comores." />
        <meta property="og:title" content="Connexion - Komorotel" />
        <meta property="og:description" content="Accédez à votre espace utilisateur et gérez vos séjours." />
        <meta property="og:image" content="https://komorotel.com/images/logo.png" />
        <meta property="og:url" content="https://komorotel.com/business/login" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Connexion - Komorotel" />
        <meta name="twitter:description" content="Connectez-vous à Komorotel pour gérer vos réservations." />
        <meta name="twitter:image" content="https://komorotel.com/images/logo.png" />
      </Helmet>
      <Header disabled={true} />
      <Container>
        <Grid container spacing={3} justifyContent="center" alignItems="center" className="pt-7">
          <Grid item xs={12} sm={8} md={6}>
            <Typography variant="h4" fontWeight="bold" textAlign="center" gutterBottom>
              <span className="bg-primary p-2 text-white rounded-3">Entreprise</span>
            </Typography>
            <Box
              className="d-flex flex-column mt-4 border shadow-sm p-4 mx-3 rounded-3 h-100"
              sx={{ padding: 4 }}
            >
              <Typography variant="h6" fontWeight="bold" gutterBottom>
                Se connecter ou créer un compte
              </Typography>
              <Typography variant="body1" color="textSecondary" gutterBottom>
                Entrez vos informations afin de pouvoir profiter de nos services
              </Typography>
              <form noValidate validated={validated} onSubmit={handleSubmit}>
                <TextField
                  fullWidth
                  label="Adresse e-mail"
                  type="email"
                  id="email"
                  value={credidentials.email}
                  onChange={handleChange}
                  required
                  margin="normal"
                  variant="outlined"
                />
                <TextField
                  fullWidth
                  label="Mot de passe"
                  type={showPassword ? "text" : "password"}  // Affiche ou masque le mdp
                  id="password"
                  value={credidentials.password}
                  onChange={handleChange}
                  required
                  margin="normal"
                  variant="outlined"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={handleClickShowPassword}
                          edge="end"
                          color="primary"
                          aria-label={showPassword ? "Masquer le mot de passe" : "Afficher le mot de passe"}
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    )
                  }}
                />
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 1 }}>
                  <MuiLink
                    component={RouterLink}
                    to="/forgot-password"
                    underline="hover"
                    sx={{ fontSize: '0.9rem', fontWeight: '500' }}
                    color="primary"
                  >
                    Mot de passe oublié ?
                  </MuiLink>
                </Box>
                <Box className="d-flex flex-column" marginTop={3}>
                  {error && (
                    <Alert severity="error" sx={{ mt: 2 }}>
                      {error.message || "Une erreur est survenue."}
                    </Alert>
                  )}
                  <Button
                    type="submit"
                    disabled={loading}
                    variant="contained"
                    color="primary"
                    sx={{ marginTop: 3 }}
                  >
                    Confirmer
                  </Button>
                </Box>
              </form>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </>
  );
}
